// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2wLc5","upload":"Small_upload__1fE_h","imageWrap":"Small_imageWrap__2EFRY","removeBtn":"Small_removeBtn__3NT-8"};